module.exports = __webpack_public_path__ + "static/media/site.a15e2de8.png";